export const STANDARD_FIELDS = [
  ["khasra", "Khasra No."], ["owner", "Owner"], ["village", "Village"], ["district", "District"],
  ["area_ha", "Area"], ["land_type", "Land type"], ["survey_year", "Survey year"],
];

// Common column spellings seen in CG revenue KML/shapefiles → standard field.
const AUTO = {
  khasra: /^(khasra|khasra_?no|kh_?no|khno|kh|plot_?no|survey_?no|sur_?no|parcel_?no|ownkhasra|khasra_number)$/i,
  owner: /^(owner|owner_?name|own_?n(a)?me?|ownr|bhumiswami|malik|name_of_owner)$/i,
  village: /^(village|vill|vill_?name|village_?name|gram|mauza|mouza|vlg)$/i,
  district: /^(district|dist|dist_?name|district_?name|zila|jila)$/i,
  area_ha: /^(area|area_?ha|area_?hect|hectare|ha|area_?h|rakba|area_?sqm|shape_?area)$/i,
  land_type: /^(land_?type|landuse|land_?use|lu|type|kism|kisam|land_?class|category)$/i,
  survey_year: /^(survey_?year|survey_?yea|year|yr|survey_?yr|settlement_?year)$/i,
};

// Resolve which source column feeds each standard field: explicit field_map wins, then auto-detect.
export function resolveFieldMap(layer, props) {
  const keys = Object.keys(props || {});
  const map = {};
  for (const [std] of STANDARD_FIELDS) {
    const explicit = layer.field_map?.[std];
    if (explicit && keys.includes(explicit)) { map[std] = explicit; continue; }
    if (explicit === "") continue; // admin chose "none"
    const hit = keys.find((k) => AUTO[std].test(k.trim()));
    if (hit) map[std] = hit;
  }
  return map;
}

export function featureInfo(layer, feature, latlng) {
  const props = feature.properties || {};
  const info = { layerName: layer.name, properties: props, geometry: feature.geometry || null, fieldMap: resolveFieldMap(layer, props), centroid: latlng ? { lat: latlng.lat, lng: latlng.lng } : null };
  const g = feature.geometry;
  if (g && (g.type === "Polygon" || g.type === "MultiPolygon")) {
    const rings = g.type === "Polygon" ? [g.coordinates[0]] : g.coordinates.map((p) => p[0]);
    info.area_ha = +(rings.reduce((a, r) => a + ringArea(r), 0) / 10000).toFixed(3);
  }
  return info;
}

function ringArea(coords) {
  const R = 6378137, rad = Math.PI / 180;
  let a = 0;
  for (let i = 0; i < coords.length - 1; i++) {
    const [x1, y1] = coords[i], [x2, y2] = coords[i + 1];
    a += (x2 - x1) * rad * (2 + Math.sin(y1 * rad) + Math.sin(y2 * rad));
  }
  return Math.abs((a * R * R) / 2);
}
